import React from "react";
import PageHeader from "../PageHeader/PageHeader";
import Section from "../Section/Section";
import Link from "../Link/Link";
import styles from "./Disclosures.module.less";
import { defineMessages, FormattedMessage } from "react-intl";
import longMessage from "../../../../../../../macros/longMessage.macro";
import track from "react-tracking";
const messages = defineMessages({
    header: {
        id: "disclosures.header",
        defaultMessage: "Federal and State Required Disclosures"
    },
    importantInformation: {
        id: "disclosures.importantInformation.header",
        defaultMessage: "*IMPORTANT INFORMATION*"
    },
    noticeAboutElectronicCheckConversion: {
        id: "disclosures.noticeAboutElectronicCheckConversion.header",
        defaultMessage: "NOTICE ABOUT ELECTRONIC CHECK CONVERSION"
    },
    forCaliforniaResidents: {
        id: "disclosures.forCaliforniaResidents.header",
        defaultMessage: "FOR CALIFORNIA RESIDENTS"
    },
    forColoradoResidents: {
        id: "disclosures.forColoradoResidents.header",
        defaultMessage: "FOR COLORADO RESIDENTS"
    },
    forMaineResidents: {
        id: "disclosures.forMaineResidents.header",
        defaultMessage: "FOR MAINE RESIDENTS"
    },
    forMassachusettsResidents: {
        id: "disclosures.forMassachusettsResidents.header",
        defaultMessage: "FOR MASSACHUSETTS RESIDENTS"
    },
    minnesotaLicensingInformation: {
        id: "disclosures.minnesotaLicensingInformation.header",
        defaultMessage: "MINNESOTA LICENSING INFORMATION"
    },
    forNevadaResidentsRegardingHospitalDebt: {
        id: "disclosures.forNevadaResidentsRegardingHospitalDebt.header",
        defaultMessage: "FOR NEVADA RESIDENTS REGARDING HOSPITAL DEBT"
    },
    forNewYorkCityResidents: {
        id: "disclosures.forNewYorkCityResidents.header",
        defaultMessage: "FOR NEW YORK CITY RESIDENTS"
    },
    forNewYorkResidents: {
        id: "disclosures.forNewYorkResidents.header",
        defaultMessage: "FOR NEW YORK RESIDENTS"
    },
    forNorthCarolinaResidents: {
        id: "disclosures.forNorthCarolinaResidents.header",
        defaultMessage: "FOR NORTH CAROLINA RESIDENTS"
    },
    forTennesseeResidents: {
        id: "disclosures.forTennesseeResidents.header",
        defaultMessage: "FOR TENNESSEE RESIDENTS"
    },
    forWisconsinResidents: {
        id: "disclosures.forWisconsinResidents.header",
        defaultMessage: "FOR WISCONSIN RESIDENTS"
    }
});
const HoursOfOperation = () => (<p className={styles.hoursOfOperation}>
		<FormattedMessage id="disclosures.hoursOfOperation" defaultMessage="Hours of operation: Monday – Thursday, 7:00am – 7:00pm, Friday, 7:00am – 5:00pm"/>
	</p>);
const Disclosures = () => (<div className={styles.wrapper}>
		<PageHeader header={messages.header}/>

		<Section title={messages.importantInformation}>
			<FormattedMessage tagName="p" id="disclosures.importantInformation.1" defaultMessage={longMessage `
					Under the law we are required to notify you of the following information. This list does not include a
					complete list of rights consumers have under State and Federal Laws.
				`}/>

			<FormattedMessage tagName="p" id="disclosures.importantInformation.2" defaultMessage={longMessage `
					This company is a debt collector attempting to collect a debt and any information obtained will be used
					for that purpose. Calls may be monitored or recorded.
				`}/>
		</Section>

		{process.env.CLIENT === "CapOne" && (<Section title={messages.noticeAboutElectronicCheckConversion}>
			<FormattedMessage id="disclosures.noticeAboutElectronicCheckConversion" defaultMessage={longMessage `
					When you provide a check as payment, you authorize us to either use the information from the check to make a
					one-time electronic funds transfer from that bank account, or to process the payment as a check transaction.
					When we use information from the check to make an electronic funds transfer, funds may be withdrawn from
					that bank account as soon as the same day we receive payment, and you will not receive the check back.
				`}/>
		</Section>)}

		<Section title={messages.forCaliforniaResidents}>
			<FormattedMessage id="disclosures.forCaliforniaResidents" defaultMessage={longMessage `
					The state Rosenthal Fair Debt Collection Practices Act and the federal Fair Debt Collection Practices Act require that,
					except under unusual circumstances, collectors may not contact you before 8:00 a.m. or after 9:00 p.m. They may not
					harass you by using threats of violence or arrest or by using obscene language. Collectors may not use false or
					misleading statements or call you at work if they know or have reason to know that you may not receive personal
					calls at work. For the most part, collectors may not tell another person, other than your attorney or your spouse,
					about your debt. Collectors may contact another person to confirm your location or enforce a judgment. For more
					information about debt collection activities, you may contact the Federal Trade Commission at 1-877-FTC-HELP or
					www.ftc.gov. Nonprofit credit counseling services may be available in the area. For information regarding your
					CA privacy rights, please visit {link}.
				`} values={{
    link: <Link href="https://www.dcmservices.com/ca-privacy-rights"/>
}}/>
			<br />
			<br />
			<FormattedMessage id="disclosures.forCaliforniaResidents.licenseNum" defaultMessage={longMessage `California Debt Collection License Number: 10834-99.`}/>
		</Section>

		<Section title={messages.forColoradoResidents}>
			<FormattedMessage id="disclosures.forColoradoResidents" defaultMessage={longMessage `
					FOR INFORMATION ABOUT THE COLORADO FAIR DEBT COLLECTION PRACTICES ACT, SEE WWW.COAG.GOV/CAR. A consumer has
					the right to request in writing that a debt collector or collection agency cease further communication with
					the consumer. A written request to cease communication will not prohibit the debt collector or collection
					agency from taking any other action authorized by law to collect the debt. Colorado Office Information: c/o
					27 North Willerup, Suite B, Montrose, CO 81401, (970) 249-7514.
				`}/>
		</Section>

		<Section title={messages.forMaineResidents}>
			<HoursOfOperation />
		</Section>

		<Section title={messages.forMassachusettsResidents}>
			<p>
				<FormattedMessage id="disclosures.forMassachusettsResidents.1" defaultMessage="NOTICE OF IMPORTANT RIGHTS"/>
				<br />
				<FormattedMessage id="disclosures.forMassachusettsResidents.2" defaultMessage={longMessage `
						You have the right to make a written or oral request that telephone calls regarding your debt not be made to
						you at your place of employment. Any such oral request will be valid for only ten days unless you provide
						written confirmation of the request postmarked or delivered within seven days of such request. You may
						terminate this request by writing to the debt collector.
					`}/>
			</p>

			<HoursOfOperation />
		</Section>

		<Section title={messages.minnesotaLicensingInformation}>
			<FormattedMessage id="disclosures.minnesotaLicensingInformation" defaultMessage={longMessage `
					This Collection Agency is licensed by MN Commerce Dept., 85 7th Pl. E., #280, St. Paul, MN 55101, License
					No. 20598440
				`}/>
		</Section>

		<Section title={messages.forNevadaResidentsRegardingHospitalDebt}>
			<FormattedMessage id="disclosures.forNevadaResidentsRegardingHospitalDebt" defaultMessage={longMessage `
					If you pay or agree to pay the debt or any portion of the debt, such payment or agreement to pay may be
					construed as an acknowledgment of the debt and a waiver of any applicable statute of limitations set forth
					in NRS 11.190 that otherwise precludes the collection of the debt. If you do not understand or have
					questions concerning your legal rights or obligations relating to the debt, you should seek legal advice.
				`}/>
		</Section>

		<Section title={messages.forNewYorkCityResidents}>
			<FormattedMessage id="disclosures.forNewYorkCityResidents" defaultMessage={longMessage `
					New York City Department of Consumer Affairs License Number: 1239504 To discuss this account, please call
					our toll free number to speak with Tammy McDonald. A representative will be able to assist you during our
					normal business hours.
				`}/>
		</Section>

		<Section title={messages.forNewYorkResidents}>
			<FormattedMessage tagName="p" id="disclosures.forNewYorkResidents.1" defaultMessage={longMessage `
					Debt collectors, in accordance with the federal Fair Debt Collection Practices Act, 15 U.S.C. § 1692,
					are prohibited from engaging in abusive, deceptive and unfair collection efforts, including but not
					limited to:
				`}/>
			<ol>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.1.1" defaultMessage="the use or threat of violence;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.1.2" defaultMessage="the use of obscene or profane language; and"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.1.3" defaultMessage="repeated calls with the intent to annoy, abuse or harass."/>
			</ol>

			<FormattedMessage tagName="p" id="disclosures.forNewYorkResidents.2" defaultMessage={longMessage `
					If a creditor or debt collector receives a money judgment against you in court, state and federal laws
					prevent the following types of income from being taken to pay the debt:
				`}/>
			<ol>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.1" defaultMessage="Supplemental security income (SSI);"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.2" defaultMessage="Social Security;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.3" defaultMessage="Public Assistance (welfare);"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.4" defaultMessage="Spousal support, maintenance (alimony) or child support;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.5" defaultMessage="Unemployment benefits;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.6" defaultMessage="Disability benefits;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.7" defaultMessage="Workers’ compensation benefits;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.8" defaultMessage="Public or private pensions;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.9" defaultMessage="Veteran’s benefits;"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.10" defaultMessage="Federal student loans, federal student grants, and federal work study funds; and"/>
				<FormattedMessage tagName="li" id="disclosures.forNewYorkResidents.2.11" defaultMessage="Ninety percent of wages or salary earned in the last 60 days."/>
			</ol>
		</Section>

		<Section title={messages.forNorthCarolinaResidents}>
			<FormattedMessage id="disclosures.forNorthCarolinaResidents" defaultMessage="North Carolina Permit Number: 119500997"/>
		</Section>

		<Section title={messages.forTennesseeResidents}>
			<FormattedMessage id="disclosures.forTennesseeResidents" defaultMessage={longMessage `
					This Collection Agency is licensed by the Collection Service Board of the Department of Commerce and
					Insurance.
				`}/>
		</Section>

		<Section title={messages.forWisconsinResidents}>
			<FormattedMessage id="disclosures.forWisconsinResidents" defaultMessage={longMessage `
					This Collection Agency is licensed by the Division of Banking, in the Wisconsin Department of Financial
					Institutions, {link}.
				`} values={{
    link: <Link href="http://www.wdfi.org/"/>
}}/>
		</Section>
	</div>);
export default track({ page: "Disclosures" }, { dispatchOnMount: true })(Disclosures);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/Disclosures/Disclosures.tsx